import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {NavigationItem} from "../../../../../core/shared/dto/navigation/navigation-item";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../core/shared/helper/widget-function-call-back-create";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {ConfirmationService} from "primeng/api";
import {ObserverService} from "../../../../../core/shared/object/service/observer.service";
import {ActivatedRoute} from "@angular/router";
import {Subscription} from "rxjs";

@Component({
    selector: 'cf-rounding-rule-object-component',
    templateUrl: './cf-rounding-rule-object.component.html',
    standalone: false
})
export class CfRoundingRuleObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    navigationItems: NavigationItem[] = [
        {
            label: 'Berechnungsgrundlagen',
            action: 'templateCalculationBase',
            tooltip: 'Berechnungsgrundlagen',
            icon: 'fa-solid fa-calculator',
            toggleable: false,
            default: true
        },
        {
            label: 'Stornopuffer-Vorlagen',
            action: 'templateCancellationBuffer',
            tooltip: 'Stornopuffer-Vorlagen',
            icon: 'fa-solid fa-file-excel',
            toggleable: false,
            default: false
        },
        {
            label: 'Haftungsvorlagen',
            action: 'templateLiability',
            tooltip: 'Haftungsvorlagen',
            icon: 'fa-solid fa-balance-scale',
            toggleable: false,
            default: false
        }
    ];

    widgetTemplateCalculationBase: WidgetData;
    widgetTemplateCancellationBuffer: WidgetData;
    widgetTemplateLiability: WidgetData;

    private queryParamSubscription: Subscription;

    constructor(
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected confirmationService: ConfirmationService,
        protected override observerService: ObserverService,
        protected route: ActivatedRoute
    ) {
        super(coreService, messageService, confirmationService, observerService);
    }

    ngOnInit() {
        super.ngOnInit();

        this.queryParamSubscription = this.route.queryParams.subscribe(params => {
            const navItemAction = params['navItem'] && decodeURIComponent(params['navItem']);
            if (!this.navigationItems?.length) return;

            if (navItemAction) {
                const found = this.navigationItems.find(item => item.action === navItemAction);
                if (found) {
                    this.activeNavigationItems = found;
                }
            } else if (!this.activeNavigationItems) {
                this.activeNavigationItems = this.navigationItems.find(item => item.default) || this.navigationItems[0];
            }
        });
    }

    onObjectChanged() {
        this.setPageTitle(this.dto['name']);
        this.activeNavigationItems = this.navigationItems.find(item => item.default);
        this.handleNavigationItems(this.navigationItems);
        this.refreshWidgets();
    }

    refreshWidgets() {
        this.refreshTemplateCalculationBaseWidget();
        this.refreshTemplateCancellationBufferWidget();
        this.refreshTemplateLiabilityWidget();
    }

    refreshTemplateCalculationBaseWidget() {
        this.widgetTemplateCalculationBase = WidgetFactory.createWidgetListEntityBasicQl(
            'cf.roundingRule.object.templateCalculationBase.list',
            'Berechnungsgrundlagen',
            'cf.CfTemplateCalculationBase',
            [FilterCriteria.create('e.roundingRuleId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
            [],
            true
        );
        const fields: WidgetToolbarCreateInterface[] = [{fieldName: 'roundingRuleDtoId', fieldValue: this.objectIdentifier.objectId}];
        this.widgetTemplateCalculationBase.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);
    }

    refreshTemplateCancellationBufferWidget() {
        this.widgetTemplateCancellationBuffer = WidgetFactory.createWidgetListEntityBasicQl(
            'cf.roundingRule.object.templateCancellationBuffer.list',
            'Stornopuffer-Vorlagen',
            'cf.CfTemplateCancellationBuffer',
            [FilterCriteria.create('e.roundingRuleId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
            [],
            true
        );
        const fields: WidgetToolbarCreateInterface[] = [{fieldName: 'roundingRuleDtoId', fieldValue: this.objectIdentifier.objectId}];
        this.widgetTemplateCancellationBuffer.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);
    }

    refreshTemplateLiabilityWidget() {
        this.widgetTemplateLiability = WidgetFactory.createWidgetListEntityBasicQl(
            'cf.roundingRule.object.templateLiability.list',
            'Haftungsvorlagen',
            'cf.CfTemplateLiability',
            [FilterCriteria.create('e.roundingRuleId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
            [],
            true
        );
        const fields: WidgetToolbarCreateInterface[] = [{fieldName: 'roundingRuleDtoId', fieldValue: this.objectIdentifier.objectId}];
        this.widgetTemplateLiability.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        if (!this.initialized) {
            return;
        }
    }

    ngOnDestroy() {
        this.queryParamSubscription?.unsubscribe();
        super.ngOnDestroy();
    }
}
